import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "profile cart"
}
const _hoisted_2 = { class: "card profile-info full-height" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "cart__content row d-flex flex-md-row flex-column mt-4" }
const _hoisted_6 = { class: "cart__products col-md-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "cart__payment ms-auto col-lg-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "border-button mt-4 w-100",
    href: "#",
    "data-bs-toggle": "modal",
    "data-bs-target": "#contactsModal"
  }, " Контакты ")
], -1)
const _hoisted_8 = {
  key: 1,
  class: "notInfo"
}

import { ref, onMounted, computed } from "vue";
import ProductCard from "@/components/Profile/ProductCard.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
// import marketplaceService from "@/services/marketplace";
import type { Cart } from "@/services/marketplace";
// import BuyModal from "@/components/Modals/BuyModal.vue";
import ContactsModal from "@/components/Modals/ContactsModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Basket',
  setup(__props) {

const cart = ref<Cart | null>(null);

const form = ref({
  address: "",
  postal_code: "",
  phone_number: "",
});

const store = useStore();
const router = useRouter();
// const openModalSubmit = ref(false);
const loggedIn = computed(() => store.state.auth.status.loggedIn);
// const selectAll = ref(false);
const selectedProducts = ref<number[]>([]);

// const toggleModalOpen = () => {
//   document.documentElement.style.overflow = openModalSubmit.value
//     ? "auto"
//     : "hidden";
//   openModalSubmit.value = !openModalSubmit.value;
// };

const reloadCart = () => {
  store.dispatch("user/getCartItems").then((cartGet: Cart) => {
    cart.value = cartGet;
  });
};

// const goToBuy = () => {
//   marketplaceService.getBuyLink(form.value).then((res) => {
//     window.location.replace(res.order_url);
//   });
// };

// const toggleSelectAll = () => {
//   if (selectAll.value) {
//     const allProductIds =
//       cart.value?.baskets.map((item) => item.product.id) || [];
//     selectedProducts.value = allProductIds;
//   } else {
//     selectedProducts.value = [];
//   }
// };

const updateSelectedProducts = (updatedSelection: number[]) => {
  selectedProducts.value = updatedSelection;
  // updateSelectAllState();
};

// const updateSelectAllState = () => {
//   selectAll.value =
//     cart.value?.baskets.every((item) =>
//       selectedProducts.value.includes(item.product.id)
//     ) || false;
// };

// const selectedTotal = computed(() => {
//   if (!cart.value) return 0;

//   return cart.value.baskets
//     .filter((item) => selectedProducts.value.includes(item.product.id))
//     .reduce(
//       (total, item) =>
//         total +
//         (item.product.sale_price
//           ? item.product.sale_price
//           : item.product.price) *
//           item.quantity,
//       0
//     );
// });

// const formatPrice = (price: number) => {
//   return new Intl.NumberFormat("ru-RU", {
//     style: "currency",
//     currency: "RUB",
//     minimumFractionDigits: 0,
//     maximumFractionDigits: 0,
//   }).format(price);
// };

onMounted(() => {
  if (!loggedIn.value) {
    router.push("/");
  } else {
    reloadCart();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (cart.value?.baskets?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", null, [
                  _createTextVNode(" Корзина "),
                  _createElementVNode("span", null, _toDisplayString(cart.value.baskets.length) + " товаров", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cart.value.baskets, (item) => {
                    return (_openBlock(), _createBlock(ProductCard, {
                      product: item.product,
                      key: item.id,
                      id: item.id,
                      quantity: item.quantity,
                      reloadCart: reloadCart,
                      selectedProducts: selectedProducts.value,
                      "onUpdate:selectedProducts": updateSelectedProducts
                    }, null, 8, ["product", "id", "quantity", "selectedProducts"]))
                  }), 128))
                ]),
                _hoisted_7
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, "Товаров не найдено")),
    _createVNode(ContactsModal)
  ], 64))
}
}

})